import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const Properties = {
  list: (params = {}) => api.get("/properties", { params }).then(r => r.data),
  cities: () => api.get("/properties/cities").then(r => r.data),
  topPicks: () => api.get("/properties/top-picks").then(r => r.data),
  dealOfMonth: () => api.get("/properties/deal-of-month").then(r => r.data),
  byId: (id) => api.get(`/properties/${id}`).then(r => r.data),
};

export const Auth = {
  sendOtp: (phone, accept_terms = true) => api.post("/auth/send-otp", { phone, accept_terms }).then(r => r.data),
  verifyOtp: (phone, otp) => api.post("/auth/verify-otp", { phone, otp }).then(r => r.data),
  register: (payload) => api.post("/auth/register", payload).then(r => r.data),
};

export const Listings = {
  create: (payload) => api.post("/listings", payload).then(r => r.data),
};

export const ContactApi = {
  send: (payload) => api.post("/contact", payload).then(r => r.data),
};

export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
};

export const formatINRFull = (n) => {
  if (n == null || isNaN(n)) return "—";
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
};
